import styled from "vue-styled-components";

export const Content = styled.div`
    padding-inline: 1.5rem;

    .section-product-item {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    figure {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        max-height: 15rem;
        img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
    }

    & + & {
        position: relative;

        &:nth-child(3n+1) {
            &:before {
                content: '';
            }
        }

        &:before {
            content: '+';
            position: absolute;
            left: -6px;
            top: 50%;
            font-size: 20px;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }
    }

    .check-item {
        position: absolute;
        top: -1.5rem;
        right: 0;
        height: 3.5rem;
        width: 3.5rem;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        i {
            font-size: 1.6rem;
            color: ${props => props.theme?.primary_color};
        }
    }

    @media (max-width: 575px) {
        & + & {
            &:before {
                left: 50%;
                top: -3rem;
            }
            &:nth-child(3n+1) {
                &:before {
                    content: '+';
                }
            }
        }
    }
`;

export const ContentDetailed = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1rem;
    height: 100%;
    border-bottom: 1px solid ${props => props.theme?.border_color_site ?? '#dee2e6'};

    h3 {
        margin: 0;
        letter-spacing: .02rem;
        text-align: center;
        cursor: pointer;
        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;
        font-size: ${props => props.theme?.products?.font_size ?? '1.5rem'};
        font-weight: ${props => props.theme?.products?.font_weight ?? 400};
        color: ${props => props.theme?.products?.title_color ?? '#2b2b2d'};
        text-transform: ${props => props.theme?.products?.text_transform ?? 'uppercase'};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: ${props => props.theme?.products?.white_space ?? 'nowrap'};
        ${props => props.theme?.products?.white_space == 'normal' ? 'display: -webkit-box;' : ''}
        ${props => props.theme?.products?.white_space == 'normal' ? '-webkit-box-orient: vertical;' : ''}
        -webkit-line-clamp: ${props => props.theme?.products?.max_lines_title ?? 10};

        &:hover {
            text-decoration: underline;
        }
    }

    .product-to-buy-together-price {
        text-align: center;
        margin-top: 0.5rem;

        span {
            font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif; 
            color: ${props => props.theme?.products?.price_color ?? '#595959'};
            font-weight: ${props => props.theme?.products?.font_weight_price ?? 600};
            font-size: 1.7rem;
            
            &.old-banner-price {
                text-decoration: line-through;
            }
            &.old-banner-price,
            &.from-price {
                font-size: 1.4rem;
                color: ${props => props.theme?.text_site_color ?? '#4a505e'};
            }

            & + span {
                margin-left: 0.5rem;
            }
        }
    } 
`;

export const ContentGrid = styled.div`
    display: flex;
    flex-direction: column;   
    
    label {
        text-align: center;
        margin: 0;

        span, strong {
            font-size: 1.4rem;
            color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        }
        
        strong {                    
            text-transform: capitalize;
        }
    }

    ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 0.2rem;
        margin: 0;
    }
`;

export const ContentGridItem = styled.li`
    padding: 1px 5px;
    margin: 0;
    cursor: pointer;
    transition: all .2s linear;                    
    border-radius: ${props => props.theme?.products?.grid?.size?.border_radius ?? '0'};
    background: ${props => props.theme?.products?.grid?.size?.background_color ?? '#fff'};
    border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color ?? '#dfdfdf'};
    
    span {
        transition: all .2s linear;
        font-size: 1.3rem;
        color: ${props => props.theme?.products?.grid?.size?.color ?? '#000'};
    }

    &.active,
    &:hover {
        border: 1px solid ${props => props.theme?.products?.grid?.size?.border_color_active ?? '#000'};
        background: ${props => props.theme?.products?.grid?.size?.background_color_active ?? '#fff'};

        span {
            color: ${props => props.theme?.products?.grid?.size?.color_active ?? '#000'};
        }
    }

    &.disabled-item-grid {
        pointer-events: none;
        border: 1px solid red;

        span {
            text-decoration: line-through red;
            opacity: 0.7;
        }
    }

    &.item-grid-color {
        display: inline-flex;
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        padding: 0.1rem;
        border: 1px solid transparent;

        &:hover {
            border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
        }
    }

    &.active.item-grid-color {
        border: 1px solid ${props => props.theme?.products?.grid?.color?.border_color_active ?? '#000'};
        pointer-events: none;
    }

    &.disabled-item-grid.item-grid-color {
        pointer-events: none;
        position: relative;
        padding: 0;
        border: 1px solid red;
        &:after {
            content: "";
            position: absolute;
            top: -0.1rem;
            left: 1.4rem;
            width: 0.1rem;
            height: 2.9rem;
            background-color: red;
            z-index: 9;
            transform: rotate(-45deg);
        }
    }
`;
